// extracted by mini-css-extract-plugin
export default {"thankModal":"ModalThank_thankModal__17G2R","thankText":"ModalThank_thankText__IIfXq","thankBtnGreat":"ModalThank_thankBtnGreat__KsLmX"};